module.exports = __webpack_public_path__ + "static/media/verificationapp_error.f8fad437.png";